import React from 'react';
import { generateIcon, headerSortOrder, SortField, Header } from './RosterUtils';

// TODO: Update the Roster and RosterII components to use renderHeader from this file
function renderColHeader(
  header: Header,
  sortFields: SortField[],
  handleHeaderOnClick: (fields: string[]) => (e: React.MouseEvent<HTMLAnchorElement>) => void,
  headerTextClassName?: string
): JSX.Element {
  const isSortable = header.sortField?.length > 0;
  const automationId = `roster-${header.title.replace(/\s+/g, '-').toLowerCase()}`;

  if (isSortable) {
    return (
      <a
        className={headerTextClassName ? headerTextClassName : 'text--color-white'}
        data-automation={automationId}
        id={automationId}
        href='#0'
        role='button'
        onClick={handleHeaderOnClick(header.sortField)}
        onKeyDown={(e) => {
          //Since role is button, make sure to also support space key for accessibility
          if (e.key === ' ') {
            e.preventDefault();
            // eslint-disable-next-line
            handleHeaderOnClick(header.sortField)(e as any);
          }
        }}
      >
        {header.title}
        {generateIcon(header.sortField, sortFields)}
      </a>
    );
  }
  return (
    <span
      id={automationId}
      data-automation={automationId}
      aria-label={`${header.title} column, not sortable`}
      className={headerTextClassName ? headerTextClassName : ''}
    >
      {header.title}
    </span>
  );
}

export function renderHeader(
  header: Header,
  index: number,
  sortFields: SortField[],
  stickyHeaders: boolean,
  handleHeaderOnClick: (fields: string[]) => (e: React.MouseEvent<HTMLAnchorElement>) => void,
  headerTextClassName?: string
): JSX.Element {
  const key = `${header.title.replace(/\s+/g, '-').toLowerCase()}-${index}`;
  const headerSortField = header.sortField?.[header.sortField.length - 1] || '';

  return (
    <th
      scope='col'
      aria-sort={headerSortOrder(sortFields, headerSortField)}
      className={`${stickyHeaders ? 'sticky' : ''} ${header.className || ''}`}
      key={key}
    >
      {renderColHeader(header, sortFields, handleHeaderOnClick, headerTextClassName)}
    </th>
  );
}
